let globalThis = (1, eval)('this')

export const Logger = globalThis._bsLogger || globalThis.console
